var React = require('react');

function DollarSignInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.91663 4H2.66663C1.56206 4 0.666626 4.89543 0.666626 6V6C0.666626 7.10457 1.56206 8 2.66663 8H5.33329C6.43786 8 7.33329 8.89543 7.33329 10V10C7.33329 11.1046 6.43786 12 5.33329 12H1.08329","stroke":"#407A7D","strokeWidth":"1.2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M3.99994 1.33325V3.99992","stroke":"#407A7D","strokeWidth":"1.2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M3.99994 12V14.6667","stroke":"#407A7D","strokeWidth":"1.2","strokeLinecap":"round","key":2})]);
}

DollarSignInline.defaultProps = {"width":"8","height":"16","viewBox":"0 0 8 16","fill":"none"};

module.exports = DollarSignInline;

DollarSignInline.default = DollarSignInline;
